// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2qiOs","error":"Textarea_error__2z7bx","readonly":"Textarea_readonly__1VdXn","disabled":"Textarea_disabled__2NZK6"};